import React from 'react';
import { Colors } from 'library';
import { Modal, ModalFooter, PillButton, Stack, Text } from 'library/ui';
import { PaymentMethod } from './types';

interface DeleteConfirmModalProps {
    method: PaymentMethod;
    submitting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export function DeleteConfirmModal({ method, submitting, onCancel, onConfirm }: DeleteConfirmModalProps) {
    const affected = method.affected_business_locations;
    const title = affected.length > 0 ? 'Delete payment method?' : 'Confirm Delete';

    return (
        <Modal title={title} onClose={() => !submitting && onCancel()} width={460}>
            <Stack gap="md">
                <Text>Are you sure you want to remove this payment method?</Text>
                {affected.length > 0 && (
                    <Stack gap="sm">
                        <Text weight="semibold">
                            {affected.length === 1
                                ? 'This location will use your default payment method instead:'
                                : 'These locations will use your default payment method instead:'}
                        </Text>
                        <Stack gap="sm">
                            {affected.map((loc) => (
                                <Text key={loc.id} size="sm">
                                    • {loc.name ?? `Location ${loc.id}`}
                                </Text>
                            ))}
                        </Stack>
                    </Stack>
                )}
                <ModalFooter>
                    <PillButton variant="secondary" onClick={onCancel} disabled={submitting}>
                        Cancel
                    </PillButton>
                    <PillButton onClick={onConfirm} disabled={submitting} color={Colors.error}>
                        {submitting ? 'Deleting…' : 'Delete'}
                    </PillButton>
                </ModalFooter>
            </Stack>
        </Modal>
    );
}
